import { GroupHeaders } from "@components/groups/groups-constants";
import { GroupsTable } from "@components/table/groups/groups-table";
import { BaseCompanyIdProps } from "@custom-types/base-types";
import { GroupsSortBy, GroupTypes } from "@custom-types/group-types";
import { GroupsPageBulkActions } from "@pages/groups/groups-page-bulk-actions";

interface Props extends BaseCompanyIdProps {
  /** List of groups to show in table */
  groups: GroupTypes[];

  /** Flag whether it is loading some content  */
  isLoading: boolean;

  /** Current sort by value */
  sortBy: GroupsSortBy;

  /** Callback to update the sort by value */
  setSortBy: (sortBy: GroupsSortBy) => void;
}

/** Content to show for groups table */
export function GroupsPageTable({
  companyId,
  groups,
  isLoading,
  sortBy,
  setSortBy,
}: Props): JSX.Element {
  const buttonComponents = GroupsPageBulkActions({
    groups,
  });

  return (
    <GroupsTable
      companyId={companyId}
      groups={groups}
      isLoading={isLoading}
      requiredColumns={[
        GroupHeaders.thumbnail,
        GroupHeaders.name,
        GroupHeaders.members,
        GroupHeaders.projects,
        GroupHeaders.createdDate,
        GroupHeaders.options,
      ]}
      bulkActionButtons={buttonComponents}
      sortBy={sortBy}
      setSortBy={setSortBy}
    />
  );
}
